import { hasRealSupabaseConfig } from '@/lib/env';

export function PlaceholderBanner() {
  if (hasRealSupabaseConfig()) return null;
  return (
    <div
      role="status"
      className="border-b border-amber-700/30 bg-amber-100 px-4 py-2 text-center text-sm text-amber-950"
    >
      Running with placeholder Supabase env. Create a Dome-only project and fill{' '}
      <code className="font-mono text-xs">VITE_SUPABASE_*</code> — see{' '}
      <code className="font-mono text-xs">.env.example</code>.
    </div>
  );
}
